export { default as Accx } from "./accx.svg";
export { default as Aspx } from "./aspx.svg";
export { default as Csv } from "./csv.svg";
export { default as Eml } from "./eml.svg";
export { default as Excel } from "./excel.svg";
export { default as Htm } from "./htm.svg";
export { default as Html } from "./html.svg";
export { default as Jpg } from "./jpg.svg";
export { default as Jsp } from "./jsp.svg";
export { default as Mht } from "./mht.svg";
export { default as Msg } from "./msg.svg";
export { default as Odp } from "./odp.svg";
export { default as Ods } from "./ods.svg";
export { default as One } from "./one.svg";
export { default as Pdf } from "./pdf.svg";
export { default as Php } from "./php.svg";
export { default as Png } from "./png.svg";
export { default as PowerPoint } from "./power-point.svg";
export { default as Ppub } from "./ppub.svg";
export { default as Pub } from "./pub.svg";
export { default as Txt } from "./txt.svg";
export { default as Undefined } from "./undefined.svg";
export { default as Url } from "./url.svg";
export { default as Vpx } from "./vpx.svg";
export { default as Vsd } from "./vsd.svg";
export { default as Vss } from "./vss.svg";
export { default as Word } from "./word.svg";
export { default as Xml } from "./xml.svg";
export { default as Zip } from "./zip.svg";
